<script setup lang="ts">
import { englishSecondaryName } from "@verbleif/lib/src/components/LocaleSelect/locale";
import VLocaleOption from "@verbleif/lib/src/components/LocaleSelect/VLocaleOption.vue";
import { useI18n } from "@verbleif/lib/src/translations/i18n";
import { computed } from "vue";
import NavbarSettingsItem from "../NavbarSettingsItem.vue";
import { useNavbarLocale } from "./useNavbarLocale";

const { t } = useI18n();
const { languageOptions, locale } = useNavbarLocale();
const TRANSLATION_KEY = "navbar.dropdown";

const currentLanguage = computed(() => languageOptions.value.find(option => option.value === locale.value));
</script>

<template>
  <VModernSelect
    v-model="locale"
    :items="languageOptions"
    placement="left"
    :auto-size="false"
    key-field-name="value"
    search-field-name="label"
    :search-also-field-names="['englishName']"
  >
    <template #input="{ show }">
      <button
        type="button"
        class="custom-input-wrapper block w-full text-left focus-visible:ring-2 focus-visible:ring-[#4CAF58] focus-visible:outline-hidden focus-visible:ring-inset"
        @click="show"
      >
        <NavbarSettingsItem icon="languages" :text="t(`${TRANSLATION_KEY}.language`)" chevron>
          <template #trailing>
            <span v-if="currentLanguage" class="flex shrink-0 items-center gap-1.5 text-[13px] text-[#757575] dark:text-gray-400">
              <img class="h-3.5" :src="`/flags/${currentLanguage.value.toUpperCase()}.svg`" alt="">
              {{ currentLanguage.label }}
            </span>
          </template>
        </NavbarSettingsItem>
      </button>
    </template>
    <template #item="{ item, label, highlight }">
      <VLocaleOption
        :locale="item.value"
        :name="item.label"
        :flag-src="`/flags/${item.value.toUpperCase()}.svg`"
        :secondary="englishSecondaryName(item.value, item.label)"
        :label="label"
        :highlight="highlight"
      />
    </template>
  </VModernSelect>
</template>
